import React from 'react';
import { BidOrderType } from 'utils/constants';
import ErrorBoundary from 'components/common/ErrorBoundary';
import CommonBidDetails from '../CommonBidDetails';

const BiddingOrderOffers = ({ dateRange }) => (
  <ErrorBoundary>
    <CommonBidDetails
      status="ALL"
      type={BidOrderType.OFFER}
      dateRange={dateRange}
    />
  </ErrorBoundary>
);

export default BiddingOrderOffers;
